import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const FolderIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8492 13.11C17.8492 16.0917 16.0917 17.8492 13.11 17.8492H6.625C3.63583 17.8492 1.875 16.0917 1.875 13.11V6.61C1.875 3.6325 2.97 1.875 5.9525 1.875H7.61917C8.2175 1.87583 8.78083 2.15667 9.13917 2.63583L9.9 3.6475C10.26 4.12583 10.8233 4.4075 11.4217 4.40833H13.78C16.7692 4.40833 17.8725 5.93 17.8725 8.9725L17.8492 13.11Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.23413 12.0524H13.5133"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
